module.exports = __webpack_public_path__ + "img/ck.420c555.svg";